import React from 'react';
import { getStatusColor, formatDate, daysOpen, daysOpenBadgeColor } from './constants';

// Compact, selectable row in the master list (left pane). Details now render in
// the right-hand panel rather than expanding inline.
function CaseListItem({ caseItem, selected, onSelect }) {
    const colors = getStatusColor(caseItem.status);
    const data = caseItem.parsedData || {};
    const days = daysOpen(caseItem.created_at);

    return (
        <button
            type="button"
            onClick={() => onSelect(caseItem.qr_case_id)}
            className={`w-full text-left p-4 border-l-4 transition-colors ${
                selected ? 'bg-blue-50 border-blue-500' : 'border-transparent hover:bg-gray-50'
            }`}
            style={selected ? undefined : { borderLeftColor: colors.borderColor }}
        >
            <div className="flex items-center justify-between gap-2">
                <span className="font-mono font-bold text-base text-gray-900 truncate">
                    {caseItem.qr_case_id}
                    {data.amazon_case_id && (
                        <span className="text-blue-600 font-normal"> · {data.amazon_case_id}</span>
                    )}
                </span>
                <span className={`px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap ${daysOpenBadgeColor(days)}`}>
                    {days === 0 ? 'Today' : days === 1 ? '1 day' : `${days} days`}
                </span>
            </div>

            {data.item_name && (
                <div className="mt-1 text-sm text-gray-700 truncate" title={data.item_name}>
                    {data.item_name}
                </div>
            )}

            <div className="mt-2 flex items-center gap-2 flex-wrap">
                <span className={`px-2 py-0.5 rounded text-xs font-bold ${colors.bg} ${colors.text}`}>
                    {caseItem.status || 'Pending Case Creation'}
                </span>
                <span className="text-xs text-gray-500">Qty {caseItem.quantity || 0}</span>
                <span className="text-xs text-gray-500">{caseItem.photo_count || 0} photos</span>
                <span className="text-xs text-gray-400 ml-auto">{formatDate(caseItem.created_at)}</span>
            </div>
        </button>
    );
}

export default React.memo(CaseListItem);
